import React from 'react';
import Button from '@lib/components/common/Button';
import IndexPage from './IndexPage';
import IndexTableFiltersPanel from './filterComponents/IndexTableFiltersPanel';
import Loader from '../common/Loader';
import IndexTable from './IndexTable';
import IndexTablePager from './IndexTablePager';

export default class ModalIndexPage extends IndexPage {

    //rootCheckboxEnabled=()=>true;

    render() {

        return (
            <div className="modal-index-page">
                <IndexTableFiltersPanel filter={this.props.filter.viewFilters.filter(x => x.meta.visible)}
                                        onFiltersChange={this.onFiltersChange}/>

                <div style={{position: 'relative'}}>
                    {this.state.isLoading && (
                        <Loader fillContainer={true}/>
                    )}

                    {this.props.results === 0 ? (
                        <div className="index-page-no-results-message">
                            {__('No results.')}
                        </div>
                    ) : (
                        <React.Fragment>
                            <div>
                                <div className="responsive-table-container">
                                    <IndexTable
                                        results={this.state.results}
                                        options={this.props.options}
                                        orderOptions={this.props.orderOptions}
                                        columns={this.props.columns}
                                        onSortChange={this.onSortChange}
                                        onRemoveRowClick={this.onRemoveRowClick}
                                        onRootCheckboxToggled={this.onRootCheckboxToggled}
                                        multiSelectRows={this.props.multiSelectRows}
                                        onRowCheckboxToggled={this.onRowCheckboxToggled}
                                        features={[]}
                                    />
                                </div>
                            </div>

                            <div className="index-table-footer-actions-container">
                                {this.renderPager()}
                                {this.renderActionButtons()}
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        )
    }

    renderPager = () => {
        if (this.state.totalPages > 1) {
            return (
                <IndexTablePager
                    currentPage={this.state.currentPage}
                    pages={this.state.totalPages}
                    onNavigateToPageClick={this.onPagerNavigateClick}
                />
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    renderActionButtons = () => (
        this.props.renderActionButtons && this.props.renderActionButtons()
    )
}